// extracted by mini-css-extract-plugin
export default {"main":"currenciesTable_main__jLFW-","lightTable":"currenciesTable_lightTable__mNz4T","darkTable":"currenciesTable_darkTable__fFA0Y"};